import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import DataTable from 'react-data-table-component';

import { buscarRevisiones } from '../../actions/revisiones';
import { buscarSucursales } from '../../actions/sucursales';
import { buscarEmpleados } from '../../actions/empleados';
import { editarBreadcrumb } from '../../actions/breadcrumb';

import FiltrosRevision from './FiltrosRevision';

const formatNombre = (persona) => persona
    ? `${persona.nombre || ''} ${persona.apellido_paterno || ''} ${persona.apellido_materno || ''}`.trim()
    : '-';

const filtrosVacios = {
    sucursal: null,
    responsable: null,
    status: null,
    fecha_creacion_inicio: null,
    fecha_creacion_fin: null,
    fecha_revision_inicio: null,
    fecha_revision_fin: null
};

const Revisiones = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const listado = useSelector(state => state.revisiones.listado);

    const [filtrosModal, setFiltrosModal] = useState(false);
    const [filtros, setFiltros] = useState(filtrosVacios);

    useEffect(() => {
        dispatch(buscarRevisiones(filtrosVacios));
        dispatch(buscarSucursales());
        dispatch(buscarEmpleados());
        dispatch(editarBreadcrumb([
            { nombre: 'Revisiones', path: '/revisiones', activo: true }
        ]));
    }, []);

    const handleAplicarFiltros = (nuevosFiltros) => {
        setFiltros(nuevosFiltros);
        dispatch(buscarRevisiones(nuevosFiltros));
    };

    const filtrosActivos = [
        filtros.sucursal,
        filtros.responsable,
        filtros.status !== null,
        filtros.fecha_creacion_inicio,
        filtros.fecha_creacion_fin,
        filtros.fecha_revision_inicio,
        filtros.fecha_revision_fin
    ].filter(Boolean).length;

    const columns = [
        {
            name: 'Fecha creación',
            sortable: true,
            selector: row => row.fecha_creacion
                ? new Date(row.fecha_creacion).toLocaleString('es-MX', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
                : '-',
            grow: 1.5
        },
        {
            name: 'Fecha revisión',
            sortable: true,
            selector: row => row.fecha_revision
                ? new Date(row.fecha_revision).toLocaleString('es-MX', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
                : '-',
            grow: 1.5
        },
        {
            name: 'Sucursal',
            sortable: true,
            selector: row => row.sucursal?.nombre || '-',
            grow: 1.5
        },
        {
            name: 'Responsable',
            sortable: true,
            selector: row => formatNombre(row.responsable),
            grow: 1.5
        },
        {
            name: 'Confirmador',
            sortable: true,
            selector: row => row.confirmador ? formatNombre(row.confirmador) : 'Pendiente',
            grow: 1.5
        },
        {
            name: 'Status',
            sortable: true,
            cell: row => (
                <span className={`badge ${row.status === true ? 'bg-success' : 'bg-warning text-dark'}`}>
                    {row.status === true ? 'Revisada' : 'Pendiente'}
                </span>
            )
        },
        {
            name: 'Acciones',
            cell: row => (
                <Link className="btn btn-sm btn-info" to={`/revisiones/informacion/${row._id}`}>
                    <i className="fas fa-eye"></i>
                </Link>
            )
        }
    ];

    return (
        <div className="row mt-5">
            <div className="col-12 mb-4 d-flex justify-content-between align-items-center">
                <h4 className="mb-0">Revisiones</h4>
                <button className="btn btn-secondary position-relative" onClick={() => setFiltrosModal(true)}>
                    <i className="fas fa-filter me-1"></i> Filtros
                    {filtrosActivos > 0 && (
                        <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary">
                            {filtrosActivos}
                        </span>
                    )}
                </button>
            </div>

            <div className="col-12">
                <DataTable
                    columns={columns}
                    data={listado}
                    pagination
                    paginationPerPage={20}
                    paginationComponentOptions={{ rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' }}
                    highlightOnHover
                    noDataComponent="No hay revisiones registradas"
                />
            </div>

            <FiltrosRevision
                show={filtrosModal}
                handleCerrar={() => setFiltrosModal(false)}
                filtros={filtros}
                handleAplicar={handleAplicarFiltros}
            />
        </div>
    );
};

export default Revisiones;
